const maxHeight = 700;
const maxWidth = 1196;
const target = document.querySelector('.root');
let mozillaTarget = document.querySelector('.root');

export const resizeGameHandler = (isForSet = true) => {
  let scale;
  let wWidth;
  let wHeight;

  wWidth = window.innerWidth;
  wHeight = window.innerHeight;
  const widthToHeight = maxWidth / maxHeight;
  const wWidthToHeight = wWidth / wHeight;

  if (wWidthToHeight > widthToHeight) {
    wWidth = wHeight * widthToHeight;
    scale = wWidth / maxWidth;
  } else {
    wHeight = wWidth / widthToHeight;
    scale = wHeight / maxHeight;
  }

  if (!isForSet) {
    return scale;
  }

  if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
    if (mozillaTarget) {
      mozillaTarget.style.transform = `scale(${scale})`;
    } else {
      mozillaTarget = document.querySelector('.root');
      mozillaTarget.style.transform = `scale(${scale})`;
    }
  } else {
    target.style.zoom = scale;
  }
};
